import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 0px;

  @media (max-width: 768px) {
    gap: 8px;
    padding: 8px 0;
  }
`;

export const SearchWrapper = styled.div`
  width: 100%;
  padding: 2px 13px;

  @media (max-width: 768px) {
    padding: 4px 8px;
    position: sticky;
    top: 0;
    z-index: 1;
    background: ${COLOR_OPTIONS.WHITE};
  }
`;
